<template>
  <c-row>
    <c-col col="12">
      <loader v-show="loading" />
      <c-card>
        <c-card-header>
          <c-card-title>
            <strong>Informasi Transaksi Supplier</strong>
            <div class="card-header-actions">
              <date-range @select="changeDate" />
            </div>
          </c-card-title>
        </c-card-header>
        <c-card-body>
          <div style="overflow: auto">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Barcode</th>
                  <th>Product</th>
                  <th>Supplier</th>
                  <th>Nama Toko/Perusahaan</th>
                  <th>Pembeli</th>
                  <th>Tanggal Beli</th>
                  <th>Harga</th>
                  <th>Keterangan</th>
                  <th>Tanggal Return</th>
                </tr>
              </thead>
              <tbody v-if="report.data && report.data.length <= 0">
                <tr>
                  <td colspan="10" class="center">
                    Data tidak ditemukan untuk range tanggal
                    <strong
                      >{{ this.dateRange.startDate.format("DD-MMM-YYYY") }} sd.
                      {{ this.dateRange.endDate.format("DD-MMM-YYYY") }}</strong
                    >
                  </td>
                </tr>
              </tbody>
              <tbody v-if="report.data && report.data.length > 0">
                <tr v-for="(v, k) in report.data" :key="k">
                  <td>
                    <table-number
                      :page="report.paginate.current_page"
                      :size="report.paginate.per_page"
                      :index="k"
                    />
                  </td>
                  <td>{{ v.warranty }}</td>
                  <td>{{ v.item_name }}</td>
                  <td>{{ v.supplier_name }}</td>
                  <td>{{ v.company_name }}</td>
                  <td>{{ v.customer_name }}</td>
                  <td>{{ v.date_sale | dateFormat }}</td>
                  <td>{{ v.hpp | thousandSeparator }}</td>
                  <td>{{ v.description }}</td>
                  <td>{{ v.tgl_return | dateFormat }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </c-card-body>
        <c-card-footer>
          <button class="btn btn-primary">
            <i class="cil-print"></i> Print</button
          >&nbsp;
          <button class="btn btn-success" @click="exportExcel">
            <i class="cil-cloud-download"></i> Excel
          </button>
          <CPagination
            align="end"
            :active-page.sync="currentPage"
            :pages="Math.ceil(total / perPage)"
            responsive
          />
        </c-card-footer>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import { HTTPAUTH, HTTPExport } from "../../lib/httplib";
import TableNumber from "../../components/TableNumber";
import DateRange from "../../components/DateRange";
import Loader from '../../components/Loader.vue';

export default {
  data () {
    return {
      report: {},
      currentPage: 1,
      total: 0,
      perPage: 10,
      startMonth: moment(moment().format("YYYY-MM-") + "01"),
      dateRange: null,
      loading: false
    };
  },
  components: {
    TableNumber,
    DateRange,
    Loader,
  },
  created () {
    // this.dateRange = {
    //   startDate: this.startMonth,
    //   endDate: moment()
    // }
    this.getList(1, "");
  },
  methods: {
    getList (page, q) {
      var dateRange = "";
      var startDate = "";
      var endDate = "";
      if (this.dateRange) {
        startDate = this.dateRange.startDate.format("YYYY-MM-DD");
        endDate = this.dateRange.endDate.format("YYYY-MM-DD");
        dateRange = `&start_date=${startDate}&end_date=${endDate}`;
      }
      HTTPAUTH.get(
        `/api/v1/report-transaction/return-supplier?page=${page}&size=${this.perPage}&q=${q}${dateRange}`
      ).then((res) => {
        this.report = res.data;
        this.currentPage = page;
        this.total = this.report.paginate.total;
        this.$router.push({
          query: { q: q, page: page, start: startDate, end: endDate },
        });
      });
    },
    changeDate (v) {
      this.dateRange = {
        startDate: moment(v.startDate),
        endDate: moment(v.endDate),
      };
      this.getList(1, "");
    },
    async exportExcel () {
      this.loading = true
      await HTTPExport.post(`/api/v1/trans-report/return-supplier`).then(res => {
        const data = res.data.data;
        window.open(data, '_blank');
      }).catch(() => {
        this.loading = false
      })
      this.loading = false
    },
  },
  watch: {
    currentPage (pageNext) {
      const query = this.$route.query;
      var q = "";
      if (query.q) {
        q = query.q;
      }
      this.getList(pageNext, q);
    },
  },
};
</script>